/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { literal } from '../../util.type';

// TODO #4 Do budoucna je zde možnost dalších nastavení stretch.
// - https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit
/**
 * Číselník roztažení médií.
 * @enum {'CONTAIN' | 'COVER' | 'FILL'}
 * @readonly
 */
const StretchEnum = {
  /** Zobrazí celé médium uvnitř rámu. Zachová poměr stran. Může být zobrazeno černé pozadí. */
  CONTAIN: literal('CONTAIN'),
  /** Vyplní celý rám médiem. Zachová poměr stran. Může dojít k ořezu média. */
  COVER: literal('COVER'),
  /** Roztáhne médium na velikost rámu. Nezachová poměr stran. */
  FILL: literal('FILL')
};

export default StretchEnum;

// Defaultní hodnota StretchEnum - nikoliv podle specifikace,
// ale podle implementace výchozí hodnoty pro nová zařízení v Ki-Wi Serveru.
// Určeno zejména pro případy, kdy je potřeba nějaká required hodnota,
// pokud na ní nezáleží.
export const defaultStretchEnum = StretchEnum.CONTAIN;
